  <bzg-welcome-landing topTitle="{{ 'AUTOADMIN.TOP_TITLE' | translate }}" middleTitle="{{ 'AUTOADMIN.MIDDLE_TITLE' | translate }}" bottomTitle="{{ 'AUTOADMIN.BOTTOM_TITLE' | translate }}">
    <form #sendEmailForm="ngForm" class="bmc-send-password-email">
        <p class="bmc-send-password-email__paragraph">{{ 'AUTOADMIN.SEND_PASSWORD_EMAIL_DESCRIPTION' | translate }}</p>
      <div class="bz-space--stack-m">
        <bzg-input [(ngModel)]='userEmail' placeholder="{{ 'AUTOADMIN.EMAIL' | translate }}" name="userEmailInput"
            infoText="{{ 'AUTOADMIN.ONLY_REGISTERED_USERS' | translate }}" [pattern]="EMAIL_REGEXP">
            {{ 'AUTOADMIN.USER_NAME' | translate }}
            <bzg-pattern-error>{{'GLOBAL.PLEASE_ENTER_A_VALID_EMAIL' | translate}}</bzg-pattern-error>
        </bzg-input>
      </div>
    </form>
    <div class="bmc-send-password-email__buttons">
        <a class="bmc-send-password-email__buttons__link" href="javascript:;" (click)="back()">
            <svg class="bz-icon-svg bz-icon-svg--16 bmc-send-password-email__buttons__link__icon" >
                <use href="#chevron-left"></use>
            </svg>
            {{ 'AUTOADMIN.BACK' | translate }}
        </a>
        <bzg-button-primary (click)="sendEmail()">{{ 'AUTOADMIN.SEND_EMAIL' | translate }}</bzg-button-primary>
    </div>
  </bzg-welcome-landing>
